import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { DANSKE_MAANEDER } from '../../utils/dateUtils';
import styles from './CalendarHeader.module.scss';

interface CalendarHeaderProps {
  year: number;
  month: number; // 0-indexed
  onForrige: () => void;
  onNaeste: () => void;
}

const CalendarHeader: React.FC<CalendarHeaderProps> = ({ year, month, onForrige, onNaeste }) => {
  return (
    <div className={styles.header}>
      <button
        onClick={onForrige}
        className={styles.navBtn}
        aria-label="Forrige måned"
      >
        <ChevronLeftIcon className={styles.icon} />
      </button>
      <h2 className={styles.title}>
        {DANSKE_MAANEDER[month]} {year}
      </h2>
      <button
        onClick={onNaeste}
        className={styles.navBtn}
        aria-label="Næste måned"
      >
        <ChevronRightIcon className={styles.icon} />
      </button>
    </div>
  );
};

export default CalendarHeader;
